<template>
  <vs-table v-if="show" ref="table" :params="params" ></vs-table>
</template>

<script>
  import VsTable from "../../_framework/VsTable.vue";
  export default {
    name: "PettyCash",
    components: {
      VsTable
    },
    data() {
      return {
        access: {},
        show: true,
        params: {
          entity: "PettyCash",
          list: [],
          headers: {
            code: {
              title: "کد",
              type: "text"
            },
            description: {
              title: "شرح",
              type: "text"
            },
            Currency: {
              title: "نوع ارز",
              type: "text"
            },
            personCode: {
              title: "کد شخص",
              type: "text"
            },
            personName: {
              title: "نام شخص",
              type: "text"
            },
          }
        },

      };
    },


  };
</script>

<style scoped>

</style>
